import { useTranslation } from 'react-i18next';

const WebsiteSuspendedErrorBoundary = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto flex min-h-screen w-full items-center justify-center bg-gray-100 px-4 py-24">
      <div className="mx-auto max-w-max">
        <main className="sm:flex">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-3xl">
            <h1 className="text-3xl text-center font-extrabold tracking-tight text-gray-900 sm:text-5xl">
              {t('errors.website_suspended.title')}
            </h1>
            <p className="mt-2 mb-2 text-lg text-gray-500 text-center">{t('errors.website_suspended.description')}</p>
          </div>
        </main>
      </div>
    </div>
  );
};

export default WebsiteSuspendedErrorBoundary;
